import { render, staticRenderFns } from "./organizationMessage.vue?vue&type=template&id=7790a171"
import script from "./organizationMessage.vue?vue&type=script&lang=js"
export * from "./organizationMessage.vue?vue&type=script&lang=js"
import style0 from "./organizationMessage.vue?vue&type=style&index=0&id=7790a171&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports